import { render, staticRenderFns } from "./numeric-score-entry.vue?vue&type=template&id=4b68122c&scoped=true"
import script from "./numeric-score-entry.vue?vue&type=script&lang=js"
export * from "./numeric-score-entry.vue?vue&type=script&lang=js"
import style0 from "./numeric-score-entry.vue?vue&type=style&index=0&id=4b68122c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b68122c",
  null
  
)

export default component.exports